// extracted by mini-css-extract-plugin
export default {"description":"style_description__8htJZ","fade-in":"style_fade-in__4vpqL","top":"style_top__4iWJj","image":"style_image__vAs1Q"};